import { z } from "@/zod";

export const TAX_STATUS = [
  "zus_net",
  "zus_tax",
  "student_net",
  "student_tax",
  "kch_net",
  "kch_tax",
  "zus_sick_net",
  "zus_sick_tax",
] as const;

export const taxStatus = z.enum(TAX_STATUS);
